"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableBody = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var padding_1 = require("../../padding");
var ExpandableBody = function (_a) {
    var getCollapseProps = _a.getCollapseProps, children = _a.children, _b = _a.paddingX, paddingX = _b === void 0 ? 24 : _b, _c = _a.paddingBottom, paddingBottom = _c === void 0 ? 24 : _c;
    return (react_1.default.createElement(StyledBody, (0, tslib_1.__assign)({}, getCollapseProps()),
        react_1.default.createElement(padding_1.Padding, { bottom: paddingBottom, x: paddingX }, children)));
};
exports.ExpandableBody = ExpandableBody;
var StyledBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var templateObject_1;
//# sourceMappingURL=expandable-body.js.map